import { h, Host } from "@stencil/core";
import { ICON_NAMESPACE } from "../../icons/namespace";
/** Display a row of five pulsing dots, to indicate loading. */
export class LoadingDots {
  render() {
    return (h(Host, null, h("es-icon", { icon: [ICON_NAMESPACE, 'dot'], size: 14 }), h("es-icon", { icon: [ICON_NAMESPACE, 'dot'], size: 14 }), h("es-icon", { icon: [ICON_NAMESPACE, 'dot'], size: 14 }), h("es-icon", { icon: [ICON_NAMESPACE, 'dot'], size: 14 }), h("es-icon", { icon: [ICON_NAMESPACE, 'dot'], size: 14 })));
  }
  static get is() { return "es-loading-dots"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["es-loading-dots.css"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["es-loading-dots.css"]
    };
  }
}
//# sourceMappingURL=es-loading-dots.js.map
